import { set, get} from "lodash";

const useSettings = () => {
  const getSettings = () => {
    try {
      return JSON.parse(localStorage.getItem('decisively.settings') || '{}');
    } catch (e) {
      console.error('Failed to parse settings:', e);
      return {};
    }
  };

  const getSetting = (path, defaultValue) => {
    const settings = getSettings();
    return get(settings, path, defaultValue);
  };

  const setSetting = (path, value) => {
    const settings = getSettings();
    set(settings, path, value);
    localStorage.setItem('decisively.settings', JSON.stringify(settings));
  };

  return { getSetting, setSetting };
};

export default useSettings;